export const localStorageData = {
  isShowMessageAuth: "isShowMessageAuth",
  user: "cgv-innerica-escort-user",
  filter: "cgv-innerica-escort-filter",
}
export const sessionStorageData = {
  tabId: "tabId",
}

export const setDataToLocalStorage = (key, data) => {
  const preparedData = JSON.stringify(data);
  localStorage.setItem(key, preparedData);
};

export const getDataFromLocalStorage = (key) => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};
